<template>
    <div class="form-wrap">
        <v-select v-if="members.length > 0" :options="members" :reduce="member => member.id" label="name" class="vue-select" v-model="selected"/>
        <button type="button" class="btn btn-primary text-white" data-bs-toggle="modal" data-bs-target="#scanner-modal" @click="setModal">
            Scan
        </button>
    </div>

    <div class="modal" :class="{ hidden: hidden.value }" tabindex="-1" id="scanner-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Scanning</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="hidden.value = true"></button>
                </div>
                <div class="modal-body">
                    <div id="wrap-scanner"></div>
                    <div class="message" v-if="error_scan.message != ''">{{ error_scan.message }}</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary text-white" data-bs-dismiss="modal" @click="closeModal">Stop scanning</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from '@vue/runtime-core';
import vSelect from 'vue-select';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { Html5Qrcode } from "html5-qrcode";

export default {
    components: {
        vSelect,
    },
    props: {
        modelValue: String
    },
    emits: ["update:modelValue"],
    setup(props, ctx) {
        const store = useStore();
        const members = ref([]);
        
        const selected = computed({
            get() {
                return props.modelValue;
            },
            set(val) {
                ctx.emit('update:modelValue', val);
            }
        });

        const route = useRoute();
        const error_scan = reactive({
            message: '',
        });

        let scanner = "";
        let camera_id = "";

        const selectedBusinessProfile = reactive({
            corporate_id: '',
        });

        const hidden = reactive({
            value: true
        });

        onMounted(() => {            
            loadBusinessProfile();

            Html5Qrcode.getCameras().then((devices) => {
                if (devices && devices.length) {
                    camera_id = devices[0].id;
                }
            }).catch((err) => console.log(err));
        });

        const onScanSuccess = (decodedText) => {
            const member = JSON.parse(decodedText);

            const selected_member = members.value.find((v) => v.id == member.memberId);

            if (selected_member) {
                ctx.emit('update:modelValue', member.memberId);
                closeModal();
            } else {
                error_scan.message = "Member not found";

                setTimeout(() => {
                    error_scan.message = "";
                }, 1000);
            }
        }
        
        const startCamera = () => {
            scanner = new Html5Qrcode("wrap-scanner");
            const config = {fps: 4, qrbox: {width: "100%", height: "100%"}};

            scanner.start({deviceId: {exact: camera_id}}, config, onScanSuccess);
        }

        const setModal = () => {
            hidden.value = !hidden.value;
            startCamera();
        }

        const closeModal = () => {
            scanner.stop();
            hidden.value = true;
        }

        const loadBusinessProfile = () => {
            store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
                selectedBusinessProfile.corporate_id = businessProfile.corporate_id;
                loadMembers();
            });
        }

        const loadMembers = () => {
            const filter = {
                corporate_id: selectedBusinessProfile.corporate_id
            }

            store.commit('Member/add_filter', {filter});
            store.dispatch('MemberTier/read_member', route.params.id).then((data) => {
                members.value = data.data.data.map(member => ({
                    ...member,
                    name: `${member.title} ${member.first_name} ${member.last_name}`
                })) || [];
            }).catch(() => {
                members.value = [];
            });
        }

        return {
            members,
            hidden,
            setModal,
            closeModal,
            selected,
            error_scan,
        }
    }
}
</script>

<style>
    .form-wrap {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    .vue-select {
        width: 70%;
    }

    .vue-select.v-select .vs__dropdown-toggle {
        height: 40px;
    }

    .vue-select.v-select .vs__selected-options {
        width: 80%;
    }

    .vue-select.vue-select .vs__selected {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 140px;
        display: inline-block;
    }

    .modal.hidden {
        display: none;
    }

    #scanner-modal.modal #wrap-scanner video {
        width: 100% !important;
        height: 100%;
    }
</style>
